import React, { useState } from 'react';
import './DataDeletion.css'; // Custom styles for the page

const DataDeletion = () => {
  const [email, setEmail] = useState('');
  const [statusMessage, setStatusMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [alertType, setAlertType] = useState(''); // 'success' or 'error'
  const [responseDetails, setResponseDetails] = useState(null); // To store details like requestId and status

  const sanitizeEmail = (email) => {
    return email.trim().toLowerCase();
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleDeleteRequest = async () => {
    if (!email) {
      setAlertType('error');
      setStatusMessage('Please enter an email address.');
      return;
    }

    const sanitizedEmail = sanitizeEmail(email);

    if (!validateEmail(sanitizedEmail)) {
      setAlertType('error');
      setStatusMessage('Invalid email format. Please enter a valid email.');
      return;
    }

    setStatusMessage('');
    setResponseDetails(null);
    setIsLoading(true);

    try {
      const response = await fetch(`https://upload-svg-next.vercel.app/api/datadeletion?email=${encodeURIComponent(sanitizedEmail)}`, {
        method: 'GET',
      });

      const data = await response.json();

      if (data.requestId || data.status) {
        setResponseDetails({ requestId: data.requestId, status: data.status });
      }

      if (response.ok) {
        setAlertType('success');
        setStatusMessage(data.message);
      } else {
        setAlertType('error');
        setStatusMessage(data.message || 'An error occurred while submitting your request.');
      }
    } catch (error) {
      console.error('Error:', error);
      setAlertType('error');
      setStatusMessage('An unexpected error occurred. Please try again later.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="data-deletion-container">
      <h1>Data Deletion Request</h1>
      <p>
        At Number Paint, we value your privacy and provide an easy way for you to delete your data.
        You can follow the instructions below or directly submit a data deletion request using the form.
      </p>

      <div className="instructions">
        <h2>How to Delete Your Data</h2>
        <ol>
          <li>
            Send us an email at <a href="mailto:numberpaintcoloringgame@gmail.com">numberpaintcoloringgame@gmail.com</a> with the subject "Number Paint: Data Deletion Request".
          </li>
          <li>
            Include the following information in your email:
            <ul>
              <li>Your full name</li>
              <li>Your registered email address</li>
              <li>Reason for data deletion (optional)</li>
            </ul>
          </li>
          <li>
            We will process your request and confirm via email within 3 business days.
          </li>
        </ol>
      </div>

      <hr />

      <div className="direct-request">
        <h2>Submit Deletion Request Directly</h2>
        <p>Enter your email address below and submit a data deletion request directly through our system.</p>

        <input
          type="email"
          placeholder="Enter your registered email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <button onClick={handleDeleteRequest} disabled={isLoading}>
          {isLoading ? 'Submitting...' : 'Submit Deletion Request'}
        </button>

        {statusMessage && (
          <div className={`alert ${alertType}`}>
            {statusMessage}
          </div>
        )}

        {responseDetails && (
          <div className={`alert ${alertType}`}>
            <p>Request ID: {responseDetails.requestId}</p>
            <p>Status: {responseDetails.status}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default DataDeletion;
